module.exports = __webpack_public_path__ + "static/media/首图@2x.93f9ef0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_121/img/首图@2x.png
// module id = 1135
// module chunks = 0